
const SellHeroSection = () => {
  return (
    <section 
      className="py-20 bg-cover bg-center relative"
      style={{
        backgroundImage: `linear-gradient(rgba(14, 27, 42, 0.7), rgba(14, 27, 42, 0.7)), url('https://public.readdy.ai/ai/img_res/f7adb1cb4df2bac999146888a131a840.jpg')`
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="font-playfair text-5xl font-bold text-white mb-6">
          Thinking about selling your business?
        </h1>
        <p className="text-xl text-gray-200 mb-8 leading-relaxed">
          You've spent years building something meaningful. Now it's time to ensure your legacy continues while securing your financial future. We're here to make that transition as smooth and rewarding as possible.
        </p>
        <button 
          onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
          className="btn-primary text-lg px-8 py-4"
        >
          Schedule a Confidential Call
        </button>
      </div>
    </section>
  );
};

export default SellHeroSection;
